import { Extension } from '@tiptap/core';
// import { Extension, Node } from '@tiptap/core';

export interface InsertHtmlOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    insertHtml: {
      insertHTML: (HTML: string) => ReturnType;
    };
  }
}

export const InsertHtml = Extension.create<InsertHtmlOptions>({
  name: 'insertHtml',
  addCommands() {
    return {
      insertHTML: (HTML: string) => ({ commands }) => {
        return commands.insertContent(HTML);
      },
    };
  },
  /*
  addNodeView() {
    return Node.create({
      name: 'insertHtml',
      content: 'inline*',
      group: 'block',
      inline: true,
      atom: true,
      toDOM: () => ['div', { 'data-insert-html': '' }, 0],
      parseDOM: [{ tag: 'div[data-insert-html]' }],
    });
  },
  */
});
